export const DASHBOARD_ARRANGE_APPOINTMENT_MODAL = 'dashboard-arrange-appointment-modal';
